import { getEnvironmentConfig, TtmsApp } from "@tt/ttms-react-core";
import * as React from "react";
import { Resource } from "react-admin";
import { Route } from "react-router-dom";
import * as config from "./config";
import dataProvider from "./dataprovider";
import Category from "./pages/category/index";
import Comment from "./pages/comment/index";
import { Dashboard } from "./pages/dashboard/dashboard";
import Video from "./pages/video/index";
import VideoList from "./pages/video/List";
import { WatchedReportList } from "./pages/videoReport";
import { UnitReportList } from "./pages/videoUnitReport";

function setVideoLink() {
  let currentUrl = window.location.href;
  let matched = currentUrl.match(/videos\/\d*\/show/gi);
  if (matched != null) {
    currentUrl = currentUrl.replace("?#", "#");
    let index = currentUrl.indexOf("&");
    if (index > 0) {
      currentUrl = currentUrl.substring(0, index - 1);
    }
    if (currentUrl != "") {
      localStorage.setItem("showVideos", currentUrl);
    }
  }
}
const envConfig = getEnvironmentConfig(config);
const App = () => {
  setVideoLink();
  return (
    <TtmsApp
      config={envConfig}
      dataProvider={dataProvider}
      dashboard={Dashboard}
      customRoutes={[<Route exact path="/anasayfa" component={Dashboard} />, <Route exact path="/video-list" component={VideoList} />]}
    >
      <Resource name="videos" {...Video} />
      <Resource name="traxchapters" />
      <Resource name="videochapters" />
      <Resource name="videostatuss" />
      <Resource name="interactions" />
      <Resource name="categorys" {...Category} />
      <Resource name="videoreports" list={WatchedReportList} />
      <Resource name="videounitreports" list={UnitReportList} />
      <Resource name="comments" {...Comment} />
    </TtmsApp>
  );
};

export default App;
